module.exports = __webpack_public_path__ + "img/kas.b2e81a9f.png";